// NIP w panelu (24.10.2026). LUSTRO Login/backend/lib/daneFirmyPoNip.js#poprawnyNip: ta sama
// reguła (10 cyfr, suma kontrolna z wagami 6-5-7-2-3-4-5-6-7, kreski, spacje i przedrostek PL
// dozwolone), żeby przycisk „Pobierz dane” nie wysyłał do rejestru NIP-u, który serwer odrzuci.

const WAGI = [6, 5, 7, 2, 3, 4, 5, 6, 7];

/** Same cyfry NIP-u albo `null`, gdy to nie jest poprawny NIP. */
export function poprawnyNip(wartosc) {
  const cyfry = String(wartosc ?? '').replace(/^\s*PL/i, '').replace(/[\s-]/g, '');
  if (!/^\d{10}$/.test(cyfry)) return null;
  const kontrolna = WAGI.reduce((s, w, i) => s + w * Number(cyfry[i]), 0) % 11;
  if (kontrolna === 10 || kontrolna !== Number(cyfry[9])) return null;
  return cyfry;
}
